'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { ConditionalWrapper } from '../../index.js';
export const Select = React.forwardRef((props, ref) => {
    const { className, selectedValue, defaultValue, items = [], ariaDescribedBy, onChange, firstOption, float = true } = props, other = __rest(props, ["className", "selectedValue", "defaultValue", "items", "ariaDescribedBy", "onChange", "firstOption", "float"]);
    const componentClassName = classnames('sparky-c-select', className, {
        'sparky-c-select--no-float': float === false,
    });
    const [valueState, setValueState] = React.useState(defaultValue);
    const isControlled = React.useRef(selectedValue !== undefined).current;
    const activeValue = isControlled
        ? selectedValue || defaultValue
        : valueState;
    const handleChangeRef = React.useRef(onChange);
    React.useEffect(() => {
        handleChangeRef.current = onChange;
    });
    const setActiveValue = (e) => {
        const update = handleChangeRef.current;
        if (isControlled) {
            onChange === null || onChange === void 0 ? void 0 : onChange(e);
        }
        else {
            setValueState(e.target.value);
            update === null || update === void 0 ? void 0 : update(e);
        }
    };
    return (_jsxs("select", Object.assign({ ref: ref, value: activeValue, onChange: setActiveValue, className: componentClassName, "aria-describedby": ariaDescribedBy }, other, { children: [firstOption, _jsx(SelectOptions, { items: items })] })));
});
Select.displayName = 'Select';
function SelectOptions({ items }) {
    return (_jsx(_Fragment, { children: items.map((item, index) => {
            return (_jsx(ConditionalWrapper, Object.assign({ condition: Array.isArray(item.value), wrapper: (children) => (_jsx(OptionGroup, Object.assign({ label: item.label }, { children: children }))) }, { children: Array.isArray(item.value) ? (_jsx(SelectOptions, { items: item.value })) : (_jsx(Option, { item: item })) }), index));
        }) }));
}
export function Option(_a) {
    var { item } = _a, other = __rest(_a, ["item"]);
    return (_jsx("option", Object.assign({ className: "sparky-c-select--option", disabled: item.disabled, value: Array.isArray(item.value) ? undefined : item.value }, other, { children: item.label })));
}
function OptionGroup(_a) {
    var { label, children } = _a, other = __rest(_a, ["label", "children"]);
    return (_jsx("optgroup", Object.assign({ className: "sparky-c-select--opt-group", label: label }, other, { children: children })));
}
//# sourceMappingURL=Select.js.map